'use client';

import { usePulseTracker } from '@cineamo/pulse/react';
import { useEffect } from 'react';

export function SpecialsPageTracker() {
    const { track } = usePulseTracker();

    useEffect(() => {
        track({
            event_type: 'series_browse',
            entity_type: 'showing_tag',
            context: {
                page: 'specials_list'
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
